/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import addOnsStatus from 'state/reducers/commentingState/addOnsStatus';
import advancedStatus from 'state/reducers/commentingState/advancedStatus';
import codeStatus from 'state/reducers/commentingState/codeStatus';
import configStatus from 'state/reducers/commentingState/configurationStatus';
import exportStatus from 'state/reducers/commentingState/exportStatus';
import statisticsStatus from 'state/reducers/commentingState/statisticsStatus';
import commentingStatus from 'state/reducers/commentingState/commentingStatus';

/* ========== ~~~~~~~~~~ COMMENTS STATE > COMMENTS MANAGEMENT STATE: ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to combine all various reducers together into an easily accesible object
// utilized in store.js
const commentsStateRootReducer = combineReducers({
    addOnsStatus,
    advancedStatus,
    codeStatus,
    configStatus,
    exportStatus,
    statisticsStatus,
    commentingStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default commentsStateRootReducer;
